import React from "react";
import styled from "styled-components";
/**
 * A simple Icon with some summary text component
 * @param {string} description Optional string to display below the icon
 * @param {Record<string, any>} descriptionStyle Styling overrides for the description text
 * @param {() => JSX.Element} icon Function returning a JSX element that is the Icon to display
 * @param {"top" | "bottom"} iconPosition Whether the icon displays on the top or bottom of the
 * summary (default: bottom)
 * @param {Record<string, any>} summaryStyle Styling overrides for the summary text
 * @param {string} summaryText The summary text (required)
 * @constructor
 */
const IconSummary = ({ description, descriptionStyle, icon, iconPosition, summaryStyle, summaryText }) => {
    const iPosition = iconPosition ?? "bottom";
    const topIcon = icon != null && iPosition === "top";
    const bottomIcon = icon != null && iPosition === "bottom";
    return (React.createElement(IconSummaryContainer, null,
        bottomIcon && React.createElement(SummaryContainer, { style: summaryStyle }, summaryText),
        React.createElement(IconContainer, null, icon()),
        description && React.createElement(DescriptionContainer, { style: descriptionStyle }, description),
        topIcon && React.createElement(SummaryContainer, { style: summaryStyle }, summaryText)));
};
const IconSummaryContainer = styled.div `
    display: flex;
    flex-direction: column;
`;
const IconContainer = styled.div `
    margin-top: 3px;
    text-align: center;
`;
const DescriptionContainer = styled.div `
    font-size: 12px;
    font-weight: 400;
    text-align: center;
`;
const SummaryContainer = styled.div `
    font-weight: 700;
    text-align: center;
`;
export default IconSummary;
